import { Box, Grid, Image } from '@chakra-ui/react';
import { GameMini } from 'src/components/common/GameMini/gameMini';
import { DotHeading } from 'src/components/common/texts/DotHeading/dotHeading';
import { FrameHeading } from 'src/components/common/texts/FrameHeading/frameHeading';
import { InputField } from '../../../inputs/InputField/inputField';
import { useFormikContext } from 'formik';
import { CartridgeModel } from 'src/components/common/CartridgeModel/cartridgeModel';
import { CartridgeInfoType } from '../SetCartridgeType/setCartridgeType';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldGroup } from '../../containers/FieldGroup/fieldGroup';
import { placeholderUrl } from 'src/config';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import ZoomGameMockUp from '../../ZoomGameMockUp/zoomGameMockUp';

export const SetSocials = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setSocials.label')}>
					{t('form.steps.setSocials.heading')}
				</FormSectionHeading>
				<Grid
					templateColumns="auto 140px"
					gridGap="20px"
					w="100%"
				>
					<InputField
						label={t('form.fields.gameWebsiteURL')}
						name="gameUrl"
						placeholder={placeholderUrl('')}
						leftText="URL"
						warningText="*"
					/>
				</Grid>
				<FormSectionAddon>
					<Box>{t('form.steps.setSocials.desc')}</Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<ZoomGameMockUp
					ctaColor={(values as any).colors.actionColor}
					textColor={(values as any).colors.textColor}
					bgColor={(values as any).colors.backgroundColor}
					zoom={{ x: 20, y: -90, width: 400, height: Number('280') }}
					name={(values as any).name}
					video={(values as any).video}
					screenshots={(values as any).screenshots}
				/>
			</RightColumn>
		</TwoColumn>
	);
};
